import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "lobby" }
const _hoisted_2 = {
  class: "lobby-hero",
  "aria-labelledby": "lobby-title"
}
const _hoisted_3 = { class: "hero-copy" }
const _hoisted_4 = { class: "hero-eyebrow" }
const _hoisted_5 = {
  key: 0,
  class: "online"
}
const _hoisted_6 = { id: "lobby-title" }
const _hoisted_7 = { class: "lobby-intro" }
const _hoisted_8 = { class: "lobby-actions" }
const _hoisted_9 = {
  id: "play-with-ai",
  class: "ai-launch"
}
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = { class: "link-label" }
const _hoisted_12 = { class: "link-label" }
const _hoisted_13 = {
  class: "hero-art",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "art-caption" }
const _hoisted_15 = { class: "lobby-content" }
const _hoisted_16 = { class: "lobby-sidebar" }
const _hoisted_17 = {
  class: "play-with-card",
  "aria-labelledby": "play-with-title"
}
const _hoisted_18 = { id: "play-with-title" }
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = { class: "support-card__heading" }
const _hoisted_21 = { class: "support-card__offer" }
const _hoisted_22 = { class: "support-card__link" }
const _hoisted_23 = { class: "leaderboard-panel" }
const _hoisted_24 = {
  class: "rooms-panel",
  "aria-labelledby": "games-title"
}
const _hoisted_25 = { class: "rooms-heading" }
const _hoisted_26 = { id: "games-title" }
const _hoisted_27 = {
  key: 0,
  class: "room-count"
}
const _hoisted_28 = ["aria-label"]
const _hoisted_29 = ["aria-pressed", "onClick"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 0,
  class: "rooms-message",
  role: "alert"
}
const _hoisted_32 = {
  key: 1,
  class: "rooms-message",
  role: "alert"
}
const _hoisted_33 = {
  key: 2,
  class: "rooms-message",
  role: "status"
}
const _hoisted_34 = {
  key: 3,
  class: "rooms-message",
  role: "status"
}
const _hoisted_35 = {
  key: 4,
  class: "games-list"
}
const _hoisted_36 = {
  class: "lobby-guide",
  "aria-labelledby": "lobby-guide-title"
}
const _hoisted_37 = { class: "guide-overview" }
const _hoisted_38 = { class: "guide-introduction" }
const _hoisted_39 = { id: "lobby-guide-title" }
const _hoisted_40 = ["aria-label"]
const _hoisted_41 = { class: "guide-start" }
const _hoisted_42 = { class: "guide-questions" }
const _hoisted_43 = { class: "guide-answer" }
const _hoisted_44 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_BotRoomButton = _resolveComponent("BotRoomButton")!
  const _component_LocaleLink = _resolveComponent("LocaleLink")!
  const _component_GiveawayBanner = _resolveComponent("GiveawayBanner")!
  const _component_RotatingTopPlayer = _resolveComponent("RotatingTopPlayer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_LobbyRoom = _resolveComponent("LobbyRoom")!
  const _component_GameGuideLinks = _resolveComponent("GameGuideLinks")!
  const _component_SocialChannels = _resolveComponent("SocialChannels")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "brand-name" }, "AVALON", -1)),
          (_ctx.online !== undefined)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('mainPage.online', { count: _ctx.online })), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('mainPage.header')), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('mainPage.intro')), 1),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_btn, {
            class: "create-room",
            color: "primary",
            size: "large",
            elevation: "0",
            onClick: _ctx.createRoom
          }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("span", {
                class: "material-icons",
                "aria-hidden": "true"
              }, "add", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('mainPage.createRoom')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_BotRoomButton, {
              color: "primary",
              variant: "outlined",
              "hide-icon": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('aiArena.playWithBots')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("nav", {
            class: "lobby-links",
            "aria-label": _ctx.$t('menu.wiki')
          }, [
            _createVNode(_component_LocaleLink, { to: { name: 'rules' } }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('mainPage.rulesLink')), 1),
                _cache[6] || (_cache[6] = _createElementVNode("span", { "aria-hidden": "true" }, "↗", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('wiki.roles')), 1),
                _cache[7] || (_cache[7] = _createElementVNode("span", { "aria-hidden": "true" }, "↗", -1))
              ]),
              _: 1
            })
          ], 8, _hoisted_10)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "hero-orbit" }, null, -1)),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "character-card character-card--morgana" }, [
          _createElementVNode("span", null, "II")
        ], -1)),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "character-card character-card--merlin" }, [
          _createElementVNode("span", null, "I")
        ], -1)),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('mainPage.heroCaption')), 1)
      ])
    ]),
    _createVNode(_component_GiveawayBanner),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("aside", _hoisted_16, [
        _createElementVNode("section", _hoisted_17, [
          _createElementVNode("h2", _hoisted_18, [
            _cache[11] || (_cache[11] = _createElementVNode("span", {
              class: "material-icons",
              "aria-hidden": "true"
            }, "groups", -1)),
            _createTextVNode(_toDisplayString(_ctx.$t('playerBoards.playWith')), 1)
          ]),
          _createElementVNode("nav", {
            "aria-label": _ctx.$t('playerBoards.playWith')
          }, [
            _createVNode(_component_LocaleLink, { to: { name: 'community_group' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('playerBoards.findTeam')), 1),
                _cache[12] || (_cache[12] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_LocaleLink, { to: { name: 'community_solo' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('playerBoards.findPlayers')), 1),
                _cache[13] || (_cache[13] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_LocaleLink, {
              class: "communities-link",
              to: { name: 'community' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('playerBoards.communities')), 1),
                _cache[14] || (_cache[14] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
              ]),
              _: 1
            })
          ], 8, _hoisted_19)
        ]),
        _createVNode(_component_LocaleLink, {
          class: "support-card",
          to: { name: 'support' }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _cache[15] || (_cache[15] = _createElementVNode("span", {
                class: "support-card__icon",
                "aria-hidden": "true"
              }, [
                _createElementVNode("svg", {
                  viewBox: "0 0 32 32",
                  fill: "none"
                }, [
                  _createElementVNode("path", {
                    d: "m5 10 6 5 5-9 5 9 6-5-3 14H8L5 10Z",
                    stroke: "currentColor",
                    "stroke-width": "1.7",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M10 28h12M11 20h10",
                    stroke: "currentColor",
                    "stroke-width": "1.7",
                    "stroke-linecap": "round"
                  }),
                  _createElementVNode("circle", {
                    cx: "16",
                    cy: "4",
                    r: "1.5",
                    fill: "currentColor"
                  })
                ])
              ], -1)),
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('support.bannerTitle')), 1)
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('support.bannerText')), 1),
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('support.lifetimePremium')) + " · $10", 1),
            _createElementVNode("span", _hoisted_22, [
              _createTextVNode(_toDisplayString(_ctx.$t('support.showBenefits')) + " ", 1),
              _cache[16] || (_cache[16] = _createElementVNode("span", {
                class: "material-icons",
                "aria-hidden": "true"
              }, "arrow_forward", -1))
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_RotatingTopPlayer),
          _createVNode(_component_LocaleLink, {
            class: "leaderboard-link",
            to: { name: 'leaderboard' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('mainPage.leaderboard')) + " ", 1),
              _cache[17] || (_cache[17] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("section", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("h2", _hoisted_26, _toDisplayString(_ctx.$t('mainPage.gamesList')), 1),
          (_ctx.roomsList)
            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.roomsList.length), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "room-filters",
          role: "group",
          "aria-label": _ctx.$t('mainPage.filterLabel')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              key: item,
              type: "button",
              "aria-pressed": _ctx.filter === item,
              class: _normalizeClass({ selected: _ctx.filter === item, 'ai-filter': item === 'ai-games' }),
              onClick: ($event: any) => (_ctx.filter = item)
            }, [
              (item === 'ai-games')
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    icon: "fa:fa-solid fa-robot",
                    size: "18",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(item === 'ai-games' ? _ctx.$t('aiArena.filterWithBots') : _ctx.$t(`mainPage.filter${item}`)) + " ", 1),
              (item === 'ai-games' ? _ctx.aiRooms !== undefined : _ctx.roomsList)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.filterCount(item)), 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_29))
          }), 128))
        ], 8, _hoisted_28),
        (_ctx.filter !== 'ai-games' && _ctx.roomsError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('errors.' + _ctx.roomsError)), 1),
              _createElementVNode("button", {
                class: "reset-filter",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.initState && _ctx.initState(...args)))
              }, _toDisplayString(_ctx.$t('mainPage.retryAi')), 1)
            ]))
          : (_ctx.filter === 'ai-games' && _ctx.aiError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('aiArena.connectionError')), 1),
                _createElementVNode("button", {
                  class: "reset-filter",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadAiRooms && _ctx.loadAiRooms(...args)))
                }, _toDisplayString(_ctx.$t('mainPage.retryAi')), 1)
              ]))
            : (_ctx.filter === 'ai-games' ? _ctx.aiLoading || !_ctx.aiRooms : !_ctx.roomsList)
              ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.$t('mainPage.loading')), 1))
              : (!_ctx.visibleRooms.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", {
                      class: "material-icons empty-icon",
                      "aria-hidden": "true"
                    }, "meeting_room", -1)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.filter === 'ai-games' || _ctx.roomsList?.length ? 'mainPage.noMatchingRooms' : 'mainPage.noRooms')), 1),
                    (_ctx.filter !== 'all')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "reset-filter",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter = 'all'))
                        }, _toDisplayString(_ctx.$t('mainPage.showAll')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleRooms.slice(0, _ctx.visibleLimit), (game) => {
                      return (_openBlock(), _createBlock(_component_LobbyRoom, {
                        key: game.uuid,
                        game: game
                      }, null, 8, ["game"]))
                    }), 128)),
                    (_ctx.visibleRooms.length > _ctx.visibleLimit)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "show-more",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visibleLimit += 8))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('mainPage.showMore')) + " ", 1),
                          _cache[19] || (_cache[19] = _createElementVNode("span", { "aria-hidden": "true" }, "↓", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
      ])
    ]),
    _createElementVNode("section", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("h2", _hoisted_39, _toDisplayString(_ctx.$t('mainPage.newPlayerTitle')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('mainPage.gameplaySummary')), 1),
          _createElementVNode("nav", {
            class: "lobby-links",
            "aria-label": _ctx.$t('menu.wiki')
          }, [
            _createVNode(_component_LocaleLink, { to: { name: 'rules' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('mainPage.rulesLink')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('wiki.roles')), 1)
              ]),
              _: 1
            })
          ], 8, _hoisted_40)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('mainPage.guideTitle')), 1),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('mainPage.guideCreate')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('mainPage.guideInvite')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('mainPage.guideStart')), 1)
          ]),
          _createVNode(_component_v_btn, {
            color: "primary",
            size: "large",
            elevation: "0",
            onClick: _ctx.createRoom
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('mainPage.createRoom')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_GameGuideLinks),
      _createElementVNode("div", _hoisted_42, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['cost', 'devices', 'conversation', 'features'], (topic) => {
          return _createElementVNode("details", {
            key: topic,
            class: "guide-question"
          }, [
            _createElementVNode("summary", null, _toDisplayString(_ctx.$t(`mainPage.guide.${topic}Title`)), 1),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`mainPage.guide.${topic}Text`)), 1),
              (topic === 'features')
                ? (_openBlock(), _createBlock(_component_LocaleLink, {
                    key: 0,
                    to: { name: 'expansions' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('breadCrumbs.expansions')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        }), 64))
      ])
    ]),
    _createVNode(_component_SocialChannels, { class: "lobby-social" }),
    _createElementVNode("nav", {
      class: "lobby-footer",
      "aria-label": _ctx.$t('menu.menu')
    }, [
      _createVNode(_component_LocaleLink, { to: { name: 'social_deduction_games_online' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.gameGuides')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'wiki' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('menu.wiki')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'stats' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('menu.stats')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'about' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('menu.about')), 1)
        ]),
        _: 1
      })
    ], 8, _hoisted_44)
  ]))
}